import { useContext } from 'react';

function useSafeContext(hook, context) {
    const value = useContext(context);
    if (!value)
        throw new Error(`${hook.name} must be used within a ${context.displayName}.Provider`);
    return value;
}

export { useSafeContext };
//# sourceMappingURL=useSafeContext.mjs.map
